import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import axios from "axios";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import VueClipboard from "vue-clipboard2";

// TODO: on serviceWorker
import "./registerServiceWorker";

import url from "@/config/url";

import filters from "@/filters";

Vue.config.productionTip = process.env.NODE_ENV === "development";

for (let name in filters) {
  Vue.filter(name, filters[name]);
}

Vue.use(VueClipboard);

axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
// axios.defaults.baseURL = `${url.DOMAIN}`;

NProgress.configure({ showSpinner: false });

router.beforeEach((to, from, next) => {
  NProgress.start();
  next();
});

router.afterEach(() => {
  NProgress.done();
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
